
import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface CoachAvailabilitySectionProps {
  availability: string[];
  onAvailabilityChange: (day: string, checked: boolean) => void;
}

const availabilityOptions = [
  'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
];

export const CoachAvailabilitySection: React.FC<CoachAvailabilitySectionProps> = ({
  availability,
  onAvailabilityChange
}) => {
  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Availability</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {availabilityOptions.map((day) => (
            <div key={day} className="flex items-center space-x-2">
              <Checkbox
                id={day}
                checked={availability.includes(day)}
                onCheckedChange={(checked) => onAvailabilityChange(day, Boolean(checked))}
              />
              <Label htmlFor={day} className="text-gray-300 text-sm cursor-pointer">
                {day}
              </Label>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
